import React, { ReactElement, Suspense } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import { Routes } from './routes'
import './i18n'
import { baseName } from './util/app_initialization/appconfig'
import { ThemeProvider } from '@amzn/storm-ui'
import { FullScreenSpinner, MOBILE_SETUP } from '@amzn/aapn-react-components'
import { overrideTheme } from 'shared/theme/override_theme'

const Site: React.FunctionComponent = (): ReactElement => {
  return (
    <ThemeProvider theme={overrideTheme(MOBILE_SETUP)}>
      <Suspense fallback={<FullScreenSpinner />}>
        <BrowserRouter basename={baseName}>
          <Routes />
        </BrowserRouter>
      </Suspense>
    </ThemeProvider>
  )
}

ReactDOM.render(<Site />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
